import { Box, Container } from '@mui/material'
import React from 'react'

import { RuleList } from '../Rules'
import WorldBasePage from '../WorldBasePage'
import Disclaimer from './Disclaimer'
import { bugFixesRules, changesRules, whyForkRules } from './rules'

const ListPage: React.FC = () => (
  <WorldBasePage>
    <Container>
      <Box display="flex" flexDirection="column">
        <Disclaimer />
      </Box>
      <Box display="flex" flexDirection="column">
        <RuleList rules={whyForkRules} title="Why did XYO World do a 3.0 Fork?" />
      </Box>
      <Box display="flex" flexDirection="column">
        <RuleList rules={bugFixesRules} title="What was fixed in XYO World 3.0?" />
      </Box>
      <Box display="flex" flexDirection="column">
        <RuleList rules={changesRules} title="What was changed in XYO World 3.0?" />
      </Box>
    </Container>
  </WorldBasePage>
)

export default ListPage
